import React, { useState } from 'react';
import PropTypes from 'prop-types';

// import Form from 'globalcomponents/UI/Form';
// import * as Yup from 'yup';
// import Accordion from '../../../components/Accordion/index';
// import Modal from 'globalcomponents/UI/Modal';
// import Button from 'globalcomponents/UI/Button';
// import ErrorIcon from 'globalcomponents/ErrorIcon';
// import SuccessIcon from 'globalcomponents/SuccessIcon';
import { UI_DATE_FORMAT } from 'globalconfig/constants/static';
import { hasValue } from 'globalutils/fmUtils';

const Component = ({
  apiStatus,
  dutyStatusReport,
  driverPerformanceReport,
  editedDataReport,
  drivingEventReport,
  eldDisconnectReport,
  odometerJumpReport,
  malfunctionReport,
  unassignedDrivingReport,
  violationReport,
  hosViolationsReport,
  rejectedEditsReport
}) => {
  return <>under maintenance</>;
};

export default Component;

Component.propTypes = {
  apiStatus: PropTypes.object.isRequired,
  dutyStatusReport: PropTypes.func.isRequired,
  driverPerformanceReport: PropTypes.func.isRequired,
  editedDataReport: PropTypes.func.isRequired,
  drivingEventReport: PropTypes.func.isRequired,
  eldDisconnectReport: PropTypes.func.isRequired,
  odometerJumpReport: PropTypes.func.isRequired,
  malfunctionReport: PropTypes.func.isRequired,
  unassignedDrivingReport: PropTypes.func.isRequired,
  violationReport: PropTypes.func.isRequired,
  hosViolationsReport: PropTypes.func.isRequired,
  rejectedEditsReport: PropTypes.func.isRequired
};
